import { IManagementUnitPagedRequest } from '../../../../model/apm/management-unit/request/management-unit-paged-request';
import { IManagementUnitResponse } from '../../../../model/apm/management-unit/response/management-unit-response';

export type ManagementUnitSearchState = {
    parameters: IManagementUnitPagedRequest;
    searchTrigger: number;
    drawer: { open: boolean; unit?: IManagementUnitResponse };
};

export enum ACTION_TYPES {
    updateParameter = 'updateParameter',
    triggerSearch = 'triggerSearch',
    openDrawer = 'openDrawer',
    closeDrawer = 'closeDrawer',
}

export const ManagementUnitSearchReducer = (state: ManagementUnitSearchState, action: any): ManagementUnitSearchState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.updateParameter:
            return { ...state, parameters: { ...state.parameters, ...payload } };
        case ACTION_TYPES.triggerSearch:
            return { ...state, searchTrigger: state.searchTrigger + 1 };
        case ACTION_TYPES.openDrawer:
            return { ...state, drawer: { open: true, unit: payload } };
        case ACTION_TYPES.closeDrawer:
            return { ...state, drawer: { open: false } };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
};
